var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utils/get-care-team.ts
import { leagueFetch } from "@leagueplatform/league-fetch";
import { captureError } from "@leagueplatform/observability";
import { deserialise } from "kitsu-core";

// src/constants/care-team.constants.ts
var CARE_TEAM_PATH = "v1/care-team";

// src/utils/get-care-team.ts
var getCareTeam = () => __async(void 0, null, function* () {
  var _a, _b, _c;
  const requestPath = `${CARE_TEAM_PATH}`;
  const response = yield leagueFetch(requestPath);
  if (response.ok) {
    const clonedResponse = yield response.clone().json();
    if (!((_c = (_b = (_a = clonedResponse.data) == null ? void 0 : _a.attributes) == null ? void 0 : _b.participant) == null ? void 0 : _c.length)) {
      captureError(
        new Error("API getCareTeam: missing participants or bad data"),
        {
          tags: { requestUrl: response.url },
          context: {
            "Response Info": {
              response: JSON.stringify(clonedResponse)
            }
          }
        }
      );
    }
  }
  return deserialise(response.json());
});
export {
  getCareTeam
};
//# sourceMappingURL=index.js.map